import { ContainerPrimary, ContainerSecondary } from "../ui";
import { Anchor } from "@/components/ui/anchor";
import { RequiredAsterisk } from "@/components/form/required-asterisk";
import { useRFS } from "@/api/rfs";
import { formatDateTime } from "@/utils/helper/formatDate";
import { DataInfoWithBadge } from "@/components/ui/data-info";
import { useRegeneratePolling } from "../../hooks/useRegeneratePolling";

export function GPONHandler({
  id,
  hasRequiredAsterisk = false,
}: {
  id: string;
  hasRequiredAsterisk?: boolean;
}) {
  const { data: rfs } = useRFS({ id });
  const { currentStatus } = useRegeneratePolling({ id });

  const isValidated = rfs?.gponStatus === "Validated";
  const shouldShowCreateButton = currentStatus == "SUCCESS";

  return (
    <ContainerPrimary>
      <span className="flex-grow whitespace-nowrap">
        GPON{hasRequiredAsterisk && <RequiredAsterisk />}
      </span>
      <ContainerSecondary className="w-fit flex-none gap-x-4">
        <>
          <div className="flex flex-col items-center text-center text-xs">
            <span className="text-center font-medium">
              Doc Uncompleted Date
            </span>
            <span className="text-center">
              {rfs?.gponUncompletedDate
                ? formatDateTime(rfs?.gponUncompletedDate)
                : "-"}
            </span>
          </div>
          <div className="flex flex-col items-center text-center text-xs">
            <span className="text-center font-medium">Doc Completed Date</span>
            <span className="text-center">
              {rfs?.gponCompletedDate
                ? formatDateTime(rfs?.gponCompletedDate)
                : "-"}
            </span>
          </div>
          <DataInfoWithBadge
            value={
              rfs?.gponIsSubmitted === true ? "Submitted" : "Not Submitted"
            }
          />

          <DataInfoWithBadge value={rfs?.gponStatus ?? "Unvalidated"} />
          <Anchor
            mood="axiata-blue-outline"
            href={`/rfs/rfs/${id}/gpon/create`}
            state={{ from: `/rfs/rfs/${id}?tab=rfs-process` }}
            className={shouldShowCreateButton ? "visible" : "invisible"}
          >
            {!isValidated ? <p>Create</p> : <p>Detail</p>}
          </Anchor>
        </>
      </ContainerSecondary>
    </ContainerPrimary>
  );
}
